import React, { useState, useEffect } from "react";
import { Typography, Box, Tab, Tabs, Button, Divider } from '@mui/material';
import axios from "axios";
import GeneralInformationBox from "../../Utilities/NCProForms/GeneralInformationBox";
import AffectedItems from "../../Utilities/NCProForms/AffectedItems";
import NonConformanceDescription from "../../Utilities/NCProForms/NonConformanceDescription";
import AdditionalInformation from "../../Utilities/NCProForms/AdditionalInformation";
import NDRCEntry from "../../Utilities/NCProForms/NDRCEntry";
import PRCEntry from "../../Utilities/NCProForms/PRCEntry";
import SRCEntry from "../../Utilities/NCProForms/SRCEntry";
import PreventiveActions from "../../Utilities/NCProForms/PreventiveActions";
import Attachments from "../../Utilities/NCProForms/Attachments";
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Modal from '@mui/material/Modal';
import Sheet from '@mui/joy/Sheet';
import ModalClose from '@mui/joy/ModalClose';
import NCRFormLabel from "../../Utilities/NCRFormLabel";
import { Textarea } from "@mui/joy";
import NCRFormHeading from "../../Utilities/NCRFormHeading";
import IICA from "../../Utilities/NCProForms/IICA";
import ProgressStepper from "../../Utilities/ProgressStepper";
import { useDispatch, useSelector } from "react-redux";
import CircularLoader from "../../Common/CircularLoader";
import { convertDBNameToUILabel } from "../../../Helpers/NCRHelpers";
import { actionSchema } from "../../../Helpers/schema";
import dayjs from 'dayjs';
import { fetchFormData, setFormData, resetFormData } from "../../../Helpers/actionFormSlice";
import { setTab } from "../../../Helpers/helperSlice";
import { fetchDashboardData } from "../../../Helpers/dashboardSlice";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function ActionComponent({ content }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lookups = useSelector((state) => state.lookup.data);
  const { tab } = useSelector((state) => state.helper);
  const [errors, setErrors] = useState();
  const [isAIrrcOpen, setAIrrcOpen] = useState(false);

  const location = useLocation();
  const initialTab = location.state?.fromRC ? tab : 0;
  const initialNcrId = location.state?.ncr_id
  const isScroll = location.state?.isScroll
  const [tabValue, setTabValue] = useState(initialTab);

  const escapePoint = lookups?.["Escape Point"] || [];
  const IICAValue = lookups?.["Implement Interim Containment Action"] || [];
  const ndrcIdentification = lookups?.["NDRC Identification"] || [];
  const RootCauseIdentification = lookups?.["Root Cause Identification"] || [];
  const srcIdentification = lookups?.["SRC Identification"] || [];
  const accessToken = localStorage.getItem('NCProAccessToken');
  const selectedFinancialYear = useSelector(state => state.dashboard.selectedFinancialYear);

  const { formData, isLoading } = useSelector((state) => state.actionForm);

  const actionFormData = {
    implement_interim_containment_action: '',
    implement_interim_containment_action_other: '',
    escape_point: '',
    ndrc_identification: '',
    corrective_actions_ndrc: "",
    process_root_cause_description: "",
    process_root_cause_identification: "",
    corrective_actions_process_root_cause: "",
    system_root_cause_identification: "",
    corrective_actions_system_root_cause: "",
    preventive_action_plan: null,
    preventive_action_implementation_timeline: null,
    action_attachments: "",
    action_attachments_file_name: "",
  }

  useEffect(() => {
    if (location.state?.fromRC) {
      dispatch(setTab(0));
    }
  }, [location.state?.fromRC, dispatch]);

  useEffect(() => {
    if (!formData || Object.keys(formData).length === 0) {
      dispatch(setFormData(actionFormData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, formData]);


  useEffect(() => {
    if (!initialNcrId && accessToken && content.ncrId) {
      dispatch(fetchFormData(content.ncrId, accessToken));
    }
  }, [accessToken, content.ncrId, dispatch, initialNcrId]);

  useEffect(() => {
    if (initialNcrId && !location.state?.fromRC) {
      dispatch(fetchFormData(initialNcrId, accessToken));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialNcrId]);

  const [aiResponses, setAiResponses] = useState({
    corrective_actions_ndrc: null,
    process_root_cause_description: null,
    corrective_actions_process_root_cause: null,
    corrective_actions_system_root_cause: null,
    preventive_action_plan: null,
    relevant_root_cause: null,
  });

  const handleActionClick = async () => {
    try {
      const formDataPayload = new FormData();
      if (formData.corrective_action_required === "No") {
        formDataPayload.append("implement_interim_containment_action", formData.implement_interim_containment_action || "");

        if (formData.implement_interim_containment_action === "Other") {
          formDataPayload.append("implement_interim_containment_action_other", formData.implement_interim_containment_action_other || "");
        }
      } else {
        const filteredFormData = {
          implement_interim_containment_action: formData.implement_interim_containment_action || "",
          escape_point: formData.escape_point || "",
          process_root_cause_identification: formData.process_root_cause_identification || "",
          ndrc_identification: formData.ndrc_identification || "",
          system_root_cause_identification: formData.system_root_cause_identification || "",
          corrective_actions_ndrc: formData.corrective_actions_ndrc || "",
          process_root_cause_description: formData.process_root_cause_description || "",
          corrective_actions_process_root_cause: formData.corrective_actions_process_root_cause || "",
          corrective_actions_system_root_cause: formData.corrective_actions_system_root_cause || "",
          preventive_action_plan: formData.preventive_action_plan || null,
        };

        const otherFieldsMapping = {
          implement_interim_containment_action: "implement_interim_containment_action_other",
          escape_point: "escape_point_other",
          process_root_cause_identification: "process_root_cause_identification_other",
          ndrc_identification: "ndrc_identification_other",
          system_root_cause_identification: "system_root_cause_identification_other",
        };

        Object.keys(otherFieldsMapping).forEach((key) => {
          if (formData[key] === "Other") {
            filteredFormData[otherFieldsMapping[key]] = formData[otherFieldsMapping[key]] || "";
          }
        });

        Object.keys(filteredFormData).forEach((key) => {
          if (filteredFormData[key] !== null && filteredFormData[key] !== undefined) {
            formDataPayload.append(key, filteredFormData[key]);
          }
        });

        if (formData.preventive_action_implementation_timeline) {
          try {
            let parsedDate;

            if (formData.preventive_action_implementation_timeline.includes("/")) {
              const [day, month, year] = formData.preventive_action_implementation_timeline.split("/");
              parsedDate = new Date(`${year}-${month}-${day}T00:00:00`);
            } else {
              parsedDate = new Date(formData.preventive_action_implementation_timeline);
            }
            if (!isNaN(parsedDate.getTime())) {
              formDataPayload.append("preventive_action_implementation_timeline", parsedDate.toISOString());
            } else {
              console.error("Invalid date format:", formData.preventive_action_implementation_timeline);
            }
          } catch (error) {
            console.error("Error parsing date:", error);
          }
        }

        if (formData.action_attachments instanceof File) {
          formDataPayload.append("action_attachments", formData.action_attachments);
        }
      }

      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/ncr/action/${formData.ncr_id}`,
        formDataPayload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        });

      if (response.data.success) {
        toast.success(response.data.message || "Form submitted Successful");
        navigate('/ncpro/action');
        dispatch(fetchDashboardData({
          startDate: selectedFinancialYear.startDate,
          endDate: selectedFinancialYear.endDate
        }));
      } else {
        toast.error(response.data.message || "Failed to submit");
      }
    } catch (error) {
      console.error('Error during submit the form:', error.response?.data || error.message);
      toast.error(error.response.data.message || "Something went wrong");
    } finally {
      setOpen(false);
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleAiResponseChange = (field, value) => {
    setAiResponses(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleChange = (updatedData) => {
    dispatch(setFormData(updatedData));

    const field = Object.keys(updatedData)[0];
    setErrors((prev) => ({
      ...prev,
      [field]: false,
      ...(updatedData.preventive_action_implementation_timeline && {
        preventive_action_implementation_timeline: false,
      }),
    }));
  };

  const handleSubmitClick = async () => {
    let requiredFields = [];

    if (formData.corrective_action_required === "No") {
      requiredFields = ["implement_interim_containment_action"];
      if (formData.implement_interim_containment_action === "Other") {
        requiredFields.push("implement_interim_containment_action_other");
      }
    } else {
      requiredFields = [
        "implement_interim_containment_action",
        "escape_point",
        "ndrc_identification",
        "corrective_actions_ndrc",
        "process_root_cause_description",
        "process_root_cause_identification",
        "corrective_actions_process_root_cause",
        "system_root_cause_identification",
        "corrective_actions_system_root_cause",
        "preventive_action_plan",
        "preventive_action_implementation_timeline"
      ];

      const otherFieldsMapping = {
        implement_interim_containment_action: "implement_interim_containment_action_other",
        escape_point: "escape_point_other",
        process_root_cause_identification: "process_root_cause_identification_other",
        ndrc_identification: "ndrc_identification_other",
        system_root_cause_identification: "system_root_cause_identification_other"
      };

      Object.keys(otherFieldsMapping).forEach((key) => {
        if (formData[key] === "Other") {
          requiredFields.push(otherFieldsMapping[key]);
        }
      });
    }

    let newErrors = {};
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field] === "") {
        newErrors[field] = `${convertDBNameToUILabel(field)} is required`;
      }
    });

    const timelineDate = dayjs(formData.preventive_action_implementation_timeline);
    if (timelineDate.isValid() && (timelineDate.year() < 1900 || timelineDate.year() > 2099)) {
      toast.error("Year must be between 1900 and 2099.");
      return;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill in all required fields.");
      return;
    }

    try {
      await actionSchema.parseAsync(formData);
      setOpen(true);
    } catch (error) {
      console.error('Error during form submission:', error.response?.data || error.errors[0]?.message);
      toast.error(error.response?.data || error.errors[0]?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    if (location.state?.isRefreshValue === 'action') dispatch(resetFormData())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.isRefreshValue]);


  useEffect(() => {
    if (initialNcrId && isScroll) {
      setTabValue(1);
      const timer = setTimeout(() => {
        const targetElement = document.getElementById("processRootCauseSection");
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [initialNcrId, isScroll]);

  return (
    <>
      {isLoading ? (
        <CircularLoader label="NCRDetails" />
      ) : (
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 14 }}>
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ pr: '4px' }}>
                <img
                  src="/images/leftArrow.png"
                  alt="Icon"
                  style={{ width: 24, height: 24, marginRight: 4, cursor: 'pointer' }}
                  onClick={() => navigate('/ncpro/action')}
                />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Lato',
                    fontSize: '18px',
                    fontWeight: 700,
                  }}
                >
                  {formData?.ncr_id} - Action
                </Typography>
              </Box>
            </Box>
            <Box>
              <ProgressStepper status={['completed', 'inProgress', 'notStarted', 'notStarted']} />
            </Box>
          </Box>
          <Box
            sx={{
              height: '75vh',
              overflow: 'auto',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor: '#fff',
              marginTop: '16px',
              '&::-webkit-scrollbar': {
                width: '7px',
                height: '7px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(211, 211, 211, 1)',
                borderRadius: '5px',
              }
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Box sx={{
                position: 'sticky',
                top: 0,
                backgroundColor: 'rgba(255, 255, 255, 1)',
                zIndex: 10,
                borderBottom: 1,
                borderColor: 'divider',
              }}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                  <Tab
                    label="General information"
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '14px',
                      fontWeight: tabValue === 0 ? '700' : '400',
                      color: tabValue === 0 ? 'rgba(42, 61, 189, 1) !Important' : 'rgba(0, 0, 0, 1) !Important',
                      lineHeight: '16.8px',
                      textTransform: 'none',
                      py: "20px"
                    }}
                  />
                  <Tab
                    label={formData.corrective_action_required === 'No' ? 'Containment action' : 'Containment action & Root cause'}
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '14px',
                      fontWeight: tabValue === 1 ? '700' : '400',
                      color: tabValue === 1 ? 'rgba(42, 61, 189, 1) !Important' : 'rgba(0, 0, 0, 1) !Important',
                      lineHeight: '16.8px',
                      textTransform: 'none',
                      py: "20px"
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={tabValue} index={0}>
                <GeneralInformationBox content={{ formData: formData, inputDisable: true }} />
                <AffectedItems content={{ formData: formData, inputDisable: true }} />
                <NonConformanceDescription content={{ formData: formData, inputDisable: true }} />
                <AdditionalInformation content={{ label: "action", formData: formData, inputDisable: true }} />
              </CustomTabPanel>
              <CustomTabPanel value={tabValue} index={1}>
                <IICA content={{ formData: formData, lookupTypes: { IICAValue }, errors: errors }} onChange={handleChange} />
                <NDRCEntry
                  content={{
                    formData: formData,
                    inputDisable: formData.corrective_action_required === 'No',
                    lookupTypes: { escapePoint, ndrcIdentification },
                    errors: errors,
                    aiResponse: {
                      corrective_actions_ndrc: aiResponses.corrective_actions_ndrc
                    },
                  }}
                  onChange={handleChange}
                  onAiResponseChange={(value) => handleAiResponseChange("corrective_actions_ndrc", value)}
                />
                <PRCEntry
                  content={{
                    formData: formData,
                    label: "action",
                    inputDisable: formData.corrective_action_required === 'No',
                    lookupTypes: { RootCauseIdentification },
                    errors: errors,
                    aiResponse: {
                      process_root_cause_description: aiResponses.process_root_cause_description,
                      corrective_actions_process_root_cause: aiResponses.corrective_actions_process_root_cause,
                      relevant_root_cause: aiResponses.relevant_root_cause,
                    },
                  }}
                  isAIrrcOpen={isAIrrcOpen}
                  setAIrrcOpen={setAIrrcOpen}
                  onChange={handleChange}
                  onAiResponseChange={(field, value) =>
                    handleAiResponseChange(field, value)
                  }
                />
                <SRCEntry
                  content={{
                    formData: formData,
                    inputDisable: formData.corrective_action_required === 'No',
                    lookupTypes: { srcIdentification },
                    errors: errors,
                    aiResponse: {
                      corrective_actions_system_root_cause: aiResponses.corrective_actions_system_root_cause,
                    },
                  }}
                  onChange={handleChange}
                  onAiResponseChange={(value) =>
                    handleAiResponseChange("corrective_actions_system_root_cause", value)
                  }
                />
                <PreventiveActions
                  content={{
                    formData: formData,
                    inputDisable: formData.corrective_action_required === 'No',
                    errors: errors,
                    aiResponse: {
                      preventive_action_plan: aiResponses.preventive_action_plan,
                    },
                  }}
                  onChange={handleChange}
                  onAiResponseChange={(value) =>
                    handleAiResponseChange("preventive_action_plan", value)
                  }
                />
                <Attachments content={{ label: "action", formData: formData, inputDisable: formData.corrective_action_required === 'No', errors: errors }} onChange={handleChange} />
              </CustomTabPanel>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: 3, py: 2,
                position: 'sticky',
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 1)',
                zIndex: 10,
                borderRadius: '0px 0px 10px 10px',
                boxShadow: '0px -1px 4px 0px rgba(0, 0, 0, 0.15)'
              }}>
                <Box sx={{ px: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    color="neutral"
                    disabled={tabValue === 0}
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '14px',
                      fontWeight: '400',
                      border: '1px solid rgba(14, 41, 102, 1) !important',
                      textTransform: 'none',
                      borderRadius: '10px',
                      color: 'rgba(14, 41, 102, 1) !important',
                      opacity: tabValue === 0 ? '70%' : '100%',
                      py: 1
                    }}
                    onClick={() => dispatch(fetchFormData(content.ncrId, accessToken, true))}
                  >
                    Reset
                  </Button>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    color="neutral"
                    disabled={tabValue === 0}
                    sx={{
                      background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                      textTransform: 'none',
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '14px',
                      fontWeight: '700',
                      color: 'rgba(255, 255, 255, 1) !important',
                      borderRadius: '10px',
                      border: 'none !important',
                      p: 1,
                      opacity: tabValue === 0 ? '70%' : '100%',
                    }}
                    onClick={handleSubmitClick}
                  >
                    Confirm & Submit
                  </Button>
                </Box>
              </Box>
              <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                onClose={() => setOpen(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <Sheet
                  variant="outlined"
                  sx={{
                    maxWidth: 800,
                    maxHeight: "80vh",
                    overflowY: "auto",
                    borderRadius: "md",
                    boxShadow: "lg",
                    '&::-webkit-scrollbar': {
                      width: '7px',
                      height: '7px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: 'rgba(211, 211, 211, 1)',
                      borderRadius: '5px',
                    }
                  }}
                >
                  <Box sx={{ position: 'sticky', top: '0', background: 'white', zIndex: '100' }}>
                    <ModalClose size='lg' variant="plain" onClick={() => setOpen(false)} />
                    <Typography component="h2" sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '16px',
                      fontWeight: '700',
                      color: 'rgba(0, 0, 0, 1)',
                      px: 3,
                      pt: 2,
                      pb: 1,
                    }}>
                      Confirm & submit
                    </Typography>
                    <Divider sx={{ mb: 2, mt: 1 }} />
                  </Box>
                  {formData.corrective_action_required === 'Yes' ?
                    <Box>
                      <Box sx={{ px: 3 }}>
                        <Box>
                          <NCRFormHeading>
                            1. Non-Detected Root Cause (NDRC) Entry
                          </NCRFormHeading>
                        </Box>
                        <Box sx={{ pb: 2 }}>
                          <NCRFormLabel sx={{ mb: 1 }}>
                            Corrective Actions for Non-Detected Root Cause (NDRC):
                          </NCRFormLabel>
                          <Textarea
                            minRows={2}
                            placeholder='No data entered'
                            name="corrective_actions_ndrc"
                            className="ncr-form-textarea"
                            disabled
                            value={formData.corrective_actions_ndrc || ''}
                            sx={{
                              width: '563px',
                              height: '109px',
                              backgroundColor: 'transparent',
                              '&.Mui-disabled': {
                                backgroundColor: 'rgba(235, 235, 235, 1)',
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      <Box sx={{ px: 3 }}>
                        <Box>
                          <NCRFormHeading>
                            2. Process Root Cause (PRC) Entry
                          </NCRFormHeading>
                        </Box>
                        <Box sx={{ pb: 2 }}>
                          <NCRFormLabel sx={{ mb: 1 }}>
                            Corrective Actions for Process Root Cause (PRC):
                          </NCRFormLabel>
                          <Textarea
                            minRows={2}
                            placeholder='No data entered'
                            name="corrective_actions_process_root_cause"
                            className="ncr-form-textarea"
                            disabled
                            value={formData.corrective_actions_process_root_cause || ''}
                            sx={{
                              width: '563px',
                              height: '109px',
                              backgroundColor: 'transparent',
                              '&.Mui-disabled': {
                                backgroundColor: 'rgba(235, 235, 235, 1)',
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      <Box sx={{ px: 3 }}>
                        <Box>
                          <NCRFormHeading sx={{ mb: 1 }}>
                            3. System Root Cause (SRC) Entry
                          </NCRFormHeading>
                        </Box>
                        <Box sx={{ pb: 2 }}>
                          <NCRFormLabel sx={{ mb: 1 }}>
                            Corrective Actions for System Root Cause (SRC):
                          </NCRFormLabel>
                          <Textarea
                            minRows={2}
                            placeholder='No data entered'
                            name="corrective_actions_system_root_cause"
                            className="ncr-form-textarea"
                            disabled
                            value={formData.corrective_actions_system_root_cause || ''}
                            sx={{
                              width: '563px',
                              height: '109px',
                              backgroundColor: 'transparent',
                              '&.Mui-disabled': {
                                fontFamily: 'Lato, sans-serif',
                                backgroundColor: 'rgba(235, 235, 235, 1)',
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      <Box sx={{ px: 3 }}>
                        <Box>
                          <NCRFormHeading sx={{ mb: 1 }}>
                            4. Preventive Actions
                          </NCRFormHeading>
                        </Box>
                        <Box sx={{ pb: 3 }}>
                          <NCRFormLabel sx={{ mb: 1 }}>
                            Preventive Action Plan:
                          </NCRFormLabel>
                          <Textarea
                            minRows={2}
                            placeholder='No data entered'
                            name="preventive_action_plan"
                            className="ncr-form-textarea"
                            disabled
                            value={formData.preventive_action_plan || ''}
                            sx={{
                              width: '563px',
                              height: '109px',
                              backgroundColor: 'transparent',
                              '&.Mui-disabled': {
                                backgroundColor: 'rgba(235, 235, 235, 1)',
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                    :
                    <Box>
                      <Box sx={{ px: 3 }}>
                        <Box>
                          <NCRFormHeading isRequired={true}>Implement Interim Containment Action</NCRFormHeading>
                        </Box>
                        <Box sx={{ pb: 2 }}>
                          <NCRFormLabel sx={{ mb: 1 }}>
                            Action:
                          </NCRFormLabel>
                          <Textarea
                            minRows={2}
                            placeholder='No data entered'
                            name="implement_interim_containment_action"
                            className="ncr-form-textarea"
                            disabled
                            value={
                              formData.implement_interim_containment_action === "Other"
                                ? formData.implement_interim_containment_action_other || ""
                                : formData.implement_interim_containment_action || ""
                            }
                            sx={{
                              width: '563px',
                              height: '109px',
                              backgroundColor: 'transparent',
                              '&.Mui-disabled': {
                                backgroundColor: 'rgba(235, 235, 235, 1)',
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  }
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: 3, py: 2,
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    zIndex: 10,
                    borderRadius: '0px 0px 10px 10px',
                    boxShadow: '0px -1px 4px 0px rgba(0, 0, 0, 0.15)'
                  }}>
                    <Box sx={{ px: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                      <Button
                        variant="outlined"
                        color="neutral"
                        onClick={() => setOpen(false)}
                        sx={{
                          fontFamily: 'Lato, sans-serif',
                          fontSize: '14px',
                          fontWeight: '400',
                          border: '1px solid rgba(14, 41, 102, 1) !important',
                          textTransform: 'none',
                          borderRadius: '10px',
                          color: 'rgba(14, 41, 102, 1) !important',
                          py: 1
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                      <Button
                        variant="outlined"
                        color="neutral"
                        sx={{
                          background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                          textTransform: 'none',
                          fontFamily: 'Lato, sans-serif',
                          fontSize: '14px',
                          fontWeight: '700',
                          color: 'rgba(255, 255, 255, 1) !important',
                          borderRadius: '10px',
                          border: 'none !important',
                          p: 1,
                          px: 2,
                        }}
                        onClick={handleActionClick}
                      >
                        Submit
                      </Button>
                    </Box>
                  </Box>
                </Sheet>
              </Modal>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}
